import apiClient from "../../utils/request";

// 获取oss签名
export function getOssPolicy() {
  return apiClient.get("/api/oss/policy");
}

//获取图标类列表
export function getIconCategoryList(params) {
  return apiClient.get("/api/icon-category",  params );
}

//保存图标信息
export function saveIconInfo(data) {
  return apiClient.post("/api/icon", data);
}

//获取图标列表
export function getIconList(params) {
  return apiClient.get("/api/icon", params);
}

//创建图标类
export function createIconCategory(data) {
  return apiClient.post("/api/icon-category", data);
}
//更新图标类
export function updateIconCategory(id, data) {
  return apiClient.patch(`/api/icon-category/${id}`, data);
}

//删除图标类
export function deleteIconCategory(id) {
  return apiClient.delete(`/api/icon-category/${id}`,{});
}

//创建图标类副本
export function duplicateIconCategory(data) {
  return apiClient.post("/api/icon-category/duplicate", data);
}

//获取副本类图标列表
export function getDuplicateIconList(params) {
  return apiClient.get("/api/icon/duplicate", params);
}

//更新图标类副本
export function updateDuplicateIconCategory(id, data) {
  return apiClient.patch(`/api/icon-category/duplicate/${id}`, data);
}

//获取项目图标类副本列表
export function getDuplicateIconCategoryList(params) {
  return apiClient.get("/api/icon-category/duplicate", params);
}